import React from 'react';
import { useDispatch } from 'react-redux';
import { Layout, Button, Popconfirm } from 'antd';
import { useHistory } from 'react-router-dom';

import { logout } from '../../actions/authentication';

import styles from './styles';

const { Header } = Layout;

const Navbar = () => {
	const history = useHistory();
	const dispatch = useDispatch();

	const handleLogoutClick = () => {
		history.push('/login');
		return dispatch(logout());
	};

	return (
		<Header style={styles.header}>
			{/* eslint-disable-next-line max-len */}
			<Popconfirm
				title="¿Estás seguro que desea cerrar sesión?"
				onConfirm={handleLogoutClick}
				onCancel={() => { }}
				okText="Si"
				cancelText="No"
			>
				<Button style={styles.headerItem} type="primary" ghost >Cerrar sesión</Button>
			</Popconfirm>
		</Header>
	);
};

export default Navbar;
